module.exports = __webpack_public_path__ + "static/media/fire-cracker.80a3ead3.svg";